import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvTaskTypes, ValidationForm } from "../_loadingHelpers/EvTask";
import Tooltip from '../../moreCore/UI/Floating/Tooltip';
class EvTaskValidationAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...


    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;
    private tableFormatterHeadings(originalHeading: string, colName: string) {
        switch (colName) {
            case "confirmationStatus":

                let employeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;

                let icon = this.createFontawesomeIcon("fas fa-user-clock");

                let tooltip = new Tooltip();
                tooltip.setup({
                    targetnode: icon,
                    content: this.translations["EvTask__ValidationAgenda_Tooltip_ConfirmationStatus"],
                    subtitle: this.translations["EvTask__ValidationAgenda_Tooltip_ConfirmationStatus_Subtitle"],
                    icon: icon.className,
                });

                return icon;


                break;
            default:
                return false;
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<EvTaskTypes.EvTaskListData>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "confirmationStatus":
                let icon = this.createFontawesomeIcon(entity.is_actual_times_confirmed_by_employee ? "far fa-check-circle primaryTXT" : "far fa-question-circle secondaryTXT");

                node.innerHTML = icon.outerHTML;
                return true;
                break;

            case "dateStartActual":
                let dateStart = new Date(entity.date_forerun);
                let dateStartAct = new Date(entity.date_start_actual);

                if (dateStart.valueOf() != dateStartAct.valueOf()) {
                    this.UiModder.domClass.add(node, "bold");
                }
                return false;
                break;
            case "dateEndActual":
                let dateEnd = new Date(entity.date_trailer);
                let dateEndAct = new Date(entity.date_end_actual);

                if (dateEnd.valueOf() != dateEndAct.valueOf()) {
                    this.UiModder.domClass.add(node, "bold");
                }
                return false;

                break;
            default:
                return false;
        }
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
       
    }

    private _onClick_Context() {

    }

   
    private _onClick_Row(row: StaticTable.StaticTableRow<EvTaskTypes.EvTaskListData>) {
        this.showTaskValidationDlg(row.rowGroup.entity);
    }
    

    private showTaskValidationDlg(data: EvTaskTypes.EvTaskListData) {
        let dlg = new GenericDialog();

        let validationForm = new ValidationForm();
        validationForm.on("saved", lang.hitch(this, this._onValidationSaved, dlg, validationForm));

        validationForm.on("saving", function () {
            dlg.disableAllButtons(true);
        });

        dlg.show(validationForm,
            this.translations["EvTaskValidation__MainTitle"],
            null,
            null,
            "close",
            lang.hitch(this, this._onTaskValidationDlgResult, dlg, validationForm)
        );

        validationForm.setup(data.ID);
    }
    private _onTaskValidationDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, registrationForm: MdsLax<InstanceType<typeof ValidationForm>>, result: number) {

    }

    private _onValidationSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, validationform: MdsLax<InstanceType<typeof ValidationForm>>, result: boolean) {

        dlg.disableAllButtons(false);


        if (result) {
            this.loadData();
        } else {
        }
    }

    private startAgenda(hasPrivilege: boolean) {
        if (!hasPrivilege) {
            this.destroy();
            return;
        }

        let today = new Date();

        this.setupAgendaView(
            "EvTask/GetValidationAgendaFilterOptions",
            "EvTask/GetValidationAgendaList",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.tableFormatter),
            null,
            null,
            null,
            today
            //lang.hitch(this, this.dateSelectFct)
            //    [{
            //        name: "default",
            //        label: "default",
            //        rows: [{
            //            attributes: ["gDisp_1"],
            //            colNamesInternal: ["gDisp_1"],
            //            colspans: [0],
            //            headings: ["Anzeige"],
            //        }]
            //    }]
        );

    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setTableHeadingFormatter(lang.hitch(this, this.tableFormatterHeadings));

        this.hasUserRole("EvTask_Validation", lang.hitch(this, this.startAgenda));
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskValidationAgenda);